/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const getTitleSlug = (title: string | undefined | null): string => {
    if (!title) {
        return '';
    }

    return title.trim().toLowerCase().replace(/ /gi, '-');
};

export const getContentType = (contentType: string | undefined | null): string => {
    if (!contentType) {
        return '';
    }

    return contentType.trim().toLowerCase().replace(/_/g, '-');
};

/**
 * Builds the canonical article URL path.
 *
 * @param type - The article content type (e.g. `location_spotlight`).
 * @param title - The article title, slugified for the URL.
 * @param id - The article id.
 * @param base - Optional path prefix (e.g. `/preview` for internal apps).
 * @returns The article link path, prefixed with `base` when provided.
 */
export const generateArticleLink = (
    type: string,
    title: string,
    id: string,
    base = ''
): string => `${base}/articles/${getContentType(type)}/${getTitleSlug(title)}/${id}`;
